<template>
  <div v-show="show">
    <el-form :inline="false" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t("general.add")}}
        </el-button>
      </el-form-item>
    </el-form>

    <!--showing data-->
    <el-table :data="tableData" stripe highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('healthIns4.submission_date')" align="center">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">{{ scope.row.apply_date }}</div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns4.f_name')" align="center">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-button type="text" @click="handleFamily(scope.$index, scope.row)">
              <span>{{ scope.row.name }}</span>
            </el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns4.f_birthday')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.birthday }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns4.relation')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.applicant_relation }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns4.reason')" align="center" width="250">
        <template slot-scope="scope">
          <span v-if="scope.row.reason !== 'その他'">{{ scope.row.reason }}</span>
          <span v-if="scope.row.reason === 'その他'">{{ scope.row.other_reason }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview(scope.$index, scope.row)" plain>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!--adding new-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="170px" class="demo-ruleForm" size="mini" :label-position="labelPosition" style="margin-left:50px">

        <el-input type="hidden" v-model="ruleForm.id" />
        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('healthIns4.submission_date')" prop="apply_date">
                <el-date-picker v-model="ruleForm.apply_date" size="mini" value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns4.submission_date')">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('healthIns4.employee_id')" prop="employee_id">
                <el-select v-model="ruleForm.employee_id" style="margin-left:10px;margin-right:50px;width: 185px" size="mini" @change="employeeIdSelected()" :placeholder="$t('general.select')">
                  <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('healthIns4.relationship')" prop="applicant_relation">
                <el-select v-model="ruleForm.applicant_relation" style="margin-left:10px;margin-right:50px;width: 185px" size="mini" :placeholder="$t('general.select')">
                  <el-option v-for="item in relationship" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item> <br /></el-form-item>

              <el-form-item :label="$t('healthIns4.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.name')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('healthIns4.other_relationship')" v-if="ruleForm.applicant_relation === 'その他'">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.applicant_relation_other" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.other_relationship')"></el-input>
              </el-form-item>

            </div>
          </el-col>
        </el-row>
        <el-collapse accordion v-if="ruleForm.applicant_relation === 'その他'" style="margin-bottom: 20px;">
          <el-collapse-item :title="$t('healthIns4.applicant_info')" name="1" style="margin-left:10px; ">
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('healthIns4.apply_name')" prop="apply_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.apply_name" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_name')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('healthIns4.apply_postcode')" prop="apply_postcode">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.apply_postcode" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_postcode')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('healthIns4.apply_phone')" prop="apply_phone">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.apply_phone" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_phone_ex')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('healthIns4.apply_name_flgn')" prop="apply_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.apply_name_flgn" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_name_flgn')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('healthIns4.apply_address')" prop="apply_address">
                  <el-input type="textarea" :rows="3" prefix-icon="el-icon-edit" v-model="ruleForm.apply_address" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_address')"></el-input>
                </el-form-item>

              </el-col>
            </el-row>

          </el-collapse-item>
        </el-collapse>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('healthIns4.reason')" prop="reason">
              <el-select v-model="ruleForm.reason" style="margin-left:10px;margin-right:50px;width: 185px" size="mini" :placeholder="$t('general.select')">
                <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('healthIns4.other')" prop="other_reason" v-if="ruleForm.reason === 'その他'">
              <el-input prefix-icon="el-icon-edit" v-model="ruleForm.other_reason" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.other')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!--edit-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="60%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="170px" class="demo-ruleForm" size="medium" :label-position="labelPosition" 　style="margin-left:50px">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('healthIns4.submission_date')" prop="apply_date">
                <el-date-picker v-model="ruleForm.apply_date" size="mini" value-format="yyyy-MM-dd" style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns4.submission_date')">
                </el-date-picker>
              </el-form-item>

              <el-form-item :label="$t('healthIns4.employee_id')" prop="employee_id">
                <el-select v-model="ruleForm.employee_id" style="margin-left:10px;margin-right:50px;width: 185px" size="mini" @change="employeeIdSelected()" :placeholder="$t('general.select')">
                  <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('healthIns4.relationship')" prop="applicant_relation">
                <el-select v-model="ruleForm.applicant_relation" style="margin-left:10px;margin-right:50px;width: 185px" size="mini" :placeholder="$t('general.select')">
                  <el-option v-for="item in relationship" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-form-item> <br /></el-form-item>

              <el-form-item :label="$t('healthIns4.name')" prop="name">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.name')" readonly></el-input>
              </el-form-item>

              <el-form-item :label="$t('healthIns4.other_relationship')" v-if="ruleForm.applicant_relation === 'その他'">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.applicant_relation_other" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.other_relationship')"></el-input>
              </el-form-item>

            </div>
          </el-col>
        </el-row>
        <el-collapse accordion v-if="ruleForm.applicant_relation === 'その他'" style="margin-bottom: 20px;">
          <el-collapse-item :title="$t('healthIns4.applicant_info')" name="1" style="margin-left:10px; ">
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('healthIns4.apply_name')" prop="apply_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.apply_name" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_name')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('healthIns4.apply_postcode')" prop="apply_postcode">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.apply_postcode" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_postcode')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('healthIns4.apply_phone')" prop="apply_phone">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.apply_phone" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_phone_ex')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('healthIns4.apply_name_flgn')" prop="apply_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.apply_name_flgn" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_name_flgn')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('healthIns4.apply_address')" prop="apply_address">
                  <el-input type="textarea" :rows="3" prefix-icon="el-icon-edit" v-model="ruleForm.apply_address" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.apply_address')"></el-input>
                </el-form-item>

              </el-col>
            </el-row>

          </el-collapse-item>
        </el-collapse>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('healthIns4.reason')" prop="reason">
              <el-select v-model="ruleForm.reason" style="margin-left:10px;margin-right:50px;width: 185px" size="mini" :placeholder="$t('general.select')">
                <el-option v-for="item in reason" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('healthIns4.other')" prop="other_reason" v-if="ruleForm.reason === 'その他'">
              <el-input prefix-icon="el-icon-edit" v-model="ruleForm.other_reason" size="mini" style="margin-left:10px;width: 185px" :placeholder="$t('healthIns4.other')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!-- family data -->
    <el-dialog :title="$t('healthIns4.family')" :append-to-body="true" :visible.sync="dialogFamily" width="40%" :before-close="handleClose">
      <el-form :rules="rules" ref="ruleFamily" class="demo-ruleFamily" size="mini" :label-position="labelPosition">

        <el-table :data="familyData" highlight-current-row border style="width: 100%" :empty-text="$t('healthIns4.empty_data')">
          <el-table-column :label="$t('healthIns4.employee_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.employee_id }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('healthIns4.f_name')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name_family }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('healthIns4.f_birthday')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.birthday | formatDate }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('healthIns4.relation')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.relation }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="cancel()" type="primary" size="medium">{{$t("healthIns4.close")}}
        </el-button>
      </span>
    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>



<script>
export default {
  data() {
    return {
      labelPosition: "left",
      value: "",
      ruleForm: {
        id: "",
        apply_date: "",
        apply_name_flgn: "",
        apply_name: "",
        apply_address: "",
        apply_postcode: "",
        apply_phone: "",
        applicant_relation: "",
        applicant_relation_other: "",
        reason: "",
        dependent: false,
        other_reason: "",

        delegator_send_date: "",
        delegator_name: "",
        delegator_address: "",
        delegator_relation: "",

        employee_id: "",

        name: "",
        birthday: "",
      },
      empList: [{
        id: "",
        employee_id: "",
        name: "",
      },],
      empList1: [],
      emp: {
        id: "",
        employee_id: "",
        name: "",
      },
      ruleFamily: [{
        name_family: "",
        gender: "",
        relation: "",
        mynum: "",
        birthday: "",
      },],
      relationship: [{
        value: "本人",
        label: this.$t("healthIns4.self"),
      },
      {
        value: "その他",
        label: this.$t("healthIns4.other"),
      },
      ],
      reason: [{
        value: "国民健康保険の加入（脱退） 手続き",
        label: this.$t("healthIns4.join"),
      },
      {
        value: "その他",
        label: this.$t("healthIns4.other"),
      },
      ],
      same_person: [{
        value: "はい",
        label: this.$t("healthIns4.yes"),
      },
      {
        value: "いいえ",
        label: this.$t("healthIns4.no"),
      },
      ],
      rules: {
        apply_date: [{
          required: true,
          message: this.$t("healthIns4.apply_dateRule"),
          trigger: "blur",
        },],
        delegator_send_date: [{
          required: true,
          message: this.$t("healthIns4.delegator_send_dateRule"),
          trigger: "blur",
        },],
        applicant_relation: [{
          required: true,
          message: this.$t("healthIns4.relationRule"),
          trigger: "blur",
        },],
        other_relationship: [{
          required: true,
          message: this.$t("general.inputinfo"),
          trigger: "blur",
        },],
        reason: [{
          required: true,
          message: this.$t("healthIns4.reasonRule"),
          trigger: "blur",
        },],
        other_reason: [{
          required: true,
          message: this.$t("healthIns4.other_reasonRule"),
          trigger: "blur",
        },],
        employee_id: [{
          required: true,
          message: this.$t("healthIns4.employee_idRule"),
          trigger: "blur",
        },],
        apply_phone: [
          {
            trigger: "blur",
            pattern: /^(?:|\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4})$/,
            message: this.$t("companyInfo.filltel"),
          },
        ],
      },
      tableData: [],
      familyData: [],
      search: "",
      dialogVisible: false,
      dialogUpdate: false,
      dialogDetails: false,
      dialogFamily: false,
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,
    };
  },

  methods: {
    preview(index, row) {
      var uid = window.localStorage.getItem('LoginUserId');
      window.open(
        "/pdf/健康保険・厚生年金保険　資格取得・喪失等確認請求書-" +
        row.name +
        "uid=" +
        uid +
        ".pdf"
      );
    },
    employeeIdSelected() {
      let postData = this.qs.stringify({
        employee_id: this.ruleForm.employee_id,
      });
      this.axios({
        method: "post",
        url: "/ListEmpList",
        data: postData,
      })
        .then((response) => {
          this.empList1 = response.data;
          this.emp = this.empList1[0];
          this.ruleForm.name = this.emp.name;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printPDF(index, row) {
      let postData = this.qs.stringify({
        id: row.id,
      });
      this.axios({
        method: "post",
        url: "/healthIns4PDF",
        data: postData,
      })
        .then((response) => {
          this.handleCurrentChange();
          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });
          setTimeout(()=>{this.preview(index, row);},700);
          // console.log(response);
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          console.log(error);
        });
    },

    handleEdit(index, row) {
      this.dialogUpdate = true;
      this.ruleForm = Object.assign({}, row);
    },
    handleDetails(index, row) {
      this.dialogDetails = true;
      this.ruleForm = Object.assign({}, row);
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(_ => {
          this.emptyUserData();
          done();
        })
        .catch(_ => { });
    },
    handleFamily(index, row) {
      let postData = this.qs.stringify({
        employee_id: row.employee_id,
      });
      this.axios({
        method: "post",
        url: "/listFamily",
        data: postData,
      })
        .then((response) => {
          this.familyData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.dialogFamily = true;
      localStorage.setItem("temp_id", JSON.stringify(row.employee_id));
    },

    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage,
      });
      this.axios({
        method: "post",
        url: "/pageHealthIns4",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    s1_cancel(ruleForm) {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.dialogDetails = false;
      this.dialogFamily = false;
      this.emptyUserData();
      this.$refs[ruleForm].resetFields();
    },
    cancel() {
      this.dialogUpdate = false;
      this.dialogVisible = false;
      this.dialogDetails = false;
      this.dialogFamily = false;
      this.emptyUserData();
    },

    handleDelete(index, row) {
      // console.log(index, row);
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteHealthIns4",
            data: postData,
          })
            .then((response) => {
              this.getPages();
              this.currentPage = 1;
              this.axios
                .post("/pageHealthIns4")
                .then((response) => {
                  this.tableData = response.data;
                })
                .catch((error) => {
                  console.log(error);
                });
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed"),
              });
              // console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled"),
          });
        });
    },

    emptyUserData() {
      this.ruleForm = {
        id: "",
        apply_date: "",
        apply_name_flgn: "",
        apply_name: "",
        apply_address: "",
        apply_postcode: "",
        apply_phone: "",
        applicant_relation: "",
        applicant_relation_other: "",
        reason: "",
        other_reason: "",
        dependent: false,
        delegator_send_date: "",
        delegator_name: "",
        delegator_address: "",
        delegator_relation: "",

        employee_id: "",

        name: "",
        birthday: "",
      };
    },

    addUser(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            apply_date: this.ruleForm.apply_date,
            apply_name_flgn: this.ruleForm.apply_name_flgn,
            apply_name: this.ruleForm.apply_name,
            apply_address: this.ruleForm.apply_address,
            apply_postcode: this.ruleForm.apply_postcode,
            apply_phone: this.ruleForm.apply_phone,
            applicant_relation: this.ruleForm.applicant_relation,
            applicant_relation_other: this.ruleForm.applicant_relation_other,
            reason: this.ruleForm.reason,
            other_reason: this.ruleForm.other_reason,
            dependent: this.ruleForm.dependent,
            delegator_send_date: this.ruleForm.delegator_send_date,
            delegator_name: this.ruleForm.delegator_name,
            delegator_address: this.ruleForm.delegator_address,
            delegator_relation: this.ruleForm.delegator_relation,
            employee_id: this.ruleForm.employee_id,
          });
          this.axios({
            method: "post",
            url: "/insertHealthIns4",
            data: postData,
          })
            .then((response) => {
              this.axios
                .post("/pageHealthIns4")
                .then((response) => {
                  this.tableData = response.data;
                  this.currentPage = 1;
                  this.cancel();
                  this.$message({
                    type: "success",
                    message: this.$t("general.add_completed"),
                  });
                })
                .catch((error) => {
                  this.$message({
                    type: "warning",
                    message: this.$t("general.add_failed"),
                  });
                  console.log(error);
                });
              this.getPages();
              this.dialogVisible = false;
              // console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    updateUser(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.ruleForm.id,
            apply_date: this.ruleForm.apply_date,
            apply_name_flgn: this.ruleForm.apply_name_flgn,
            apply_name: this.ruleForm.apply_name,
            apply_address: this.ruleForm.apply_address,
            apply_postcode: this.ruleForm.apply_postcode,
            apply_phone: this.ruleForm.apply_phone,
            applicant_relation: this.ruleForm.applicant_relation,
            applicant_relation_other: this.ruleForm.applicant_relation_other,
            reason: this.ruleForm.reason,
            other_reason: this.ruleForm.other_reason,
            dependent: this.ruleForm.dependent,
            delegator_send_date: this.ruleForm.delegator_send_date,
            delegator_name: this.ruleForm.delegator_name,
            delegator_address: this.ruleForm.delegator_address,
            delegator_relation: this.ruleForm.delegator_relation,
            employee_id: this.ruleForm.employee_id,
          });
          this.axios({
            method: "post",
            url: "/updateHealthIns4",
            data: postData,
          })
            .then((response) => {
              this.handleCurrentChange();
              this.s1_cancel(ruleForm);
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed"),
              });
              // console.log(response);
            })
            .catch((error) => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed"),
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    getPages() {
      this.axios
        .post("/rowsHealthIns4")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshData() {
      location.reload();
    },
  },

  created() {
    this.axios
      .post("/pageHealthIns4")
      .then((response) => {
        this.tableData = response.data;
        this.show = true;
      })
      .catch((error) => {
        this.show = false;
        this.$message({ type: 'error', message: '開発中です。' });
        console.log(error);
      });

    this.axios
      .post("/rowsHealthIns4")
      .then((response) => {
        this.total = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
    this.axios
      .post("/ListEmpListForInsNameChange")
      .then((response) => {
        // console.log(response.data);
        this.empList = response.data;
        // console.log(this.empList);
      })
      .catch((error) => {
        console.log(error);
      });
    this.axios
      .post("/listFamily")
      .then((response) => {
        // console.log(response.data);
        this.ruleFamily = response.data;
        // console.log(this.ruleFamily);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>


<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  width: 90px;
}

.btn-custom-confirm {
  width: 90px;
}
</style>
<style scoped>
.search_name {
  width: 200px;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}

.style1 {
  margin-right: 142px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/HealthIns/HealthIns4.vue